document.addEventListener('click', event => {
  const opener = event.target.closest('[data-open]');
  if (opener) document.getElementById(opener.dataset.open)?.showModal();
  const closer = event.target.closest('[data-close]');
  if (closer) closer.closest('dialog')?.close();
});
document.querySelectorAll('dialog').forEach(dialog => {
  dialog.addEventListener('click', event => {
    if (event.target === dialog) {
      const r = dialog.getBoundingClientRect();
      if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) dialog.close();
    }
  });
});


document.addEventListener('DOMContentLoaded',()=>{document.querySelectorAll('[data-mc-remote-src]').forEach((el)=>{el.src=el.dataset.mcRemoteSrc;if(el.dataset.mcRemoteSrcset)el.srcset=el.dataset.mcRemoteSrcset;});document.querySelectorAll('.mc-source-content video').forEach((el)=>el.load());});

document.addEventListener('click',(event)=>{const link=event.target.closest('a[href^="#"]');if(link){const target=document.getElementById(link.getAttribute('href').slice(1));if(target instanceof HTMLDialogElement){event.preventDefault();target.showModal();}}const close=event.target.closest('[data-mc-overview-close]');if(close){close.closest('dialog')?.close();}});document.addEventListener('click',(event)=>{const dialog=event.target;if(dialog instanceof HTMLDialogElement&&event.target===dialog){dialog.close();}});

document.querySelectorAll('[data-mc-announcements]').forEach(container => {
  const slides = [...container.querySelectorAll('[data-mc-announcement]')];
  const pause = container.querySelector('[data-mc-announcement-pause]');
  let index = 0;
  let paused = matchMedia('(prefers-reduced-motion: reduce)').matches;
  pause?.setAttribute('aria-pressed', String(paused));
  pause?.addEventListener('click', () => {
    paused = !paused;
    pause.setAttribute('aria-pressed', String(paused));
  });
  setInterval(() => {
    if (paused || document.hidden || container.matches(':hover, :focus-within')) return;
    slides[index].hidden = true;
    index = (index + 1) % slides.length;
    slides[index].hidden = false;
  }, 6000);
});

const searchInput = document.getElementById('mc-search');
const searchResults = document.getElementById('mc-predictive-results');
const searchStatus = document.getElementById('mc-search-status');
let searchTimer;
let searchRequest;
searchInput?.addEventListener('input', () => {
  clearTimeout(searchTimer);
  searchRequest?.abort();
  const query = searchInput.value.trim();
  if (query.length < 2) {
    searchResults.replaceChildren();
    searchStatus.textContent = '';
    return;
  }
  searchTimer = setTimeout(async () => {
    searchRequest = new AbortController();
    try {
      const route = `${window.Shopify?.routes?.root || '/'}search/suggest.json`;
      const params = new URLSearchParams({q: query, 'resources[type]': 'product', 'resources[limit]': '5'});
      const response = await fetch(`${route}?${params}`, {signal: searchRequest.signal});
      if (!response.ok) throw new Error('Search unavailable');
      const data = await response.json();
      if (query !== searchInput.value.trim()) return;
      const products = data.resources.results.products;
      const fragment = document.createDocumentFragment();
      products.forEach(product => {
        const link = document.createElement('a');
        link.href = product.url;
        if (product.image) {
          const image = document.createElement('img');
          image.src = product.image;
          image.alt = '';
          image.width = 44;
          image.height = 44;
          link.append(image);
        }
        const text = document.createElement('span');
        text.textContent = product.title;
        link.append(text);
        fragment.append(link);
      });
      searchResults.replaceChildren(fragment);
      searchStatus.textContent = `${searchStatus.dataset.resultsLabel} ${products.length}`;
    } catch (error) {
      if (error.name === 'AbortError') return;
      searchResults.replaceChildren();
      searchStatus.textContent = searchStatus.dataset.searchError;
    }
  }, 250);
});

document.querySelectorAll('.mc-shop-menu, .mc-collection__facets').forEach(menu => {
  menu.addEventListener('keydown', event => {
    if (event.key === 'Escape') {
      menu.open = false;
      menu.querySelector('summary')?.focus();
    }
  });
  document.addEventListener('click', event => {
    if (!menu.contains(event.target)) menu.open = false;
  });
});
document.addEventListener('click', event => {
  const closeFilter = event.target.closest('[data-mc-close-filter]');
  if (closeFilter) {
    const filter = closeFilter.closest('.mc-collection__facets');
    filter.open = false;
    filter.querySelector('summary')?.focus();
  }
});

const footerBreakpoint = matchMedia('(min-width: 750px)');
const setFooterGroups = () => document.querySelectorAll('.mc-footer-menu').forEach(group => { group.open = true; });
setFooterGroups();
footerBreakpoint.addEventListener('change', setFooterGroups);
